import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classes from '../growthBySpecializations.module.scss';
import Select from '../../../../_common/Form/Selects/Select/Select';
import Button from '../../../../_common/Form/Buttons/Button';
import { getSelectRepListRequest } from '../../../../../store/actions/users';
import { stateOptions } from '../../../../../utils/data/data';
import SelectWithSearch from '../../../../_common/Form/Selects/SelectWithSearch/SelectWithSearch';
import { clearProduct, searchProduct } from '../../../../../store/actions/dashboard';
import { useQuery } from '../../../../../utils/hooks/useQuery';
import accountHelpers from '../../../../../utils/accountHelpers';

const limit = 20;
let timeout;

const GrowthBySpecializationsFilters = ({
  setFilterData, filtersData, updateFilters, clearFilters,
}) => {
  const { query } = useQuery();
  const dispatch = useDispatch();
  const { selectRepList, pageCount, currentPage } = useSelector((store) => store.users);
  const { dashboardProduct } = useSelector((store) => store.dashboard);

  const [searchProductValue, setSearchProductValue] = useState(query.productName || '');
  const [currentSelectedProduct, setCurrentSelectedProduct] = useState(query.productName || '');
  const [searchProductLoading, setSearchProductLoading] = useState(false);

  useEffect(() => {
    dispatch(getSelectRepListRequest({ limit, role: 'Rep' }));
  }, []);

  const nextOptionListRequest = async (page) => {
    await dispatch(getSelectRepListRequest({ page, limit, role: 'Rep' }));
  };

  const changeProduct = (value) => {
    setSearchProductValue(value);

    clearTimeout(timeout);
    dispatch(clearProduct());

    if (value.trim()) {
      setSearchProductLoading(true);

      timeout = setTimeout(async () => {
        await dispatch(searchProduct(value));
        setSearchProductLoading(false);
      }, 400);
    } else {
      setSearchProductLoading(false);
    }
  };

  const changeRequestData = (path, value, searchValue) => {
    if (searchValue) {
      setSearchProductValue(searchValue);
      setCurrentSelectedProduct(searchValue);
    }

    setFilterData((prev) => ({ ...prev, [path]: value }));
  };

  const update = () => {
    updateFilters(currentSelectedProduct);
  };

  const clear = () => {
    if (searchProductValue) setSearchProductValue('');
    if (currentSelectedProduct) setCurrentSelectedProduct('');

    clearFilters();
  };

  return (
    <div className={classes.filters_wrapper}>
      {accountHelpers.getUser()?.role !== 'Rep' && (
        <div className={classes.select_wrapper}>
          <Select
            label="All reps"
            nextOptionListRequest={nextOptionListRequest}
            options={selectRepList}
            totalPage={pageCount}
            currentPage={currentPage}
            limit={limit}
            currentOption={filtersData.rep}
            onChange={(option) => changeRequestData('rep', option)}
            optionPathname="name"
          />
        </div>
      )}

      <div className={classes.select_wrapper}>
        <Select
          label="All state"
          options={stateOptions}
          currentOption={filtersData.state}
          onChange={(option) => changeRequestData('state', option)}
        />
      </div>

      <div className={classes.select_wrapper}>
        <SelectWithSearch
          label="Product"
          optionPathname="name"
          optionKey="id"
          options={dashboardProduct}
          searchValue={searchProductValue}
          onChange={changeProduct}
          loading={searchProductLoading}
          onSelectOption={(option, searchValue) => changeRequestData('productId', option, searchValue)}
        />
      </div>

      <div className={classes.btns_wrapper}>
        <Button
          title="Update"
          onClick={update}
        />

        <Button
          title="Clear"
          clearButton
          onClick={clear}
        />
      </div>
    </div>
  );
};

GrowthBySpecializationsFilters.propTypes = {
  filtersData: PropTypes.object.isRequired,
  setFilterData: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
};

export default GrowthBySpecializationsFilters;
